export const NetWorthActionTypes = {
  FETCH_NET_WORTH_START: 'FETCH_NET_WORTH_START',
  FETCH_NET_WORTH_SUCCESS: 'FETCH_NET_WORTH_SUCCESS',
  FETCH_NET_WORTH_FAILURE: 'FETCH_NET_WORTH_FAILURE',
  ADD_ASSET: 'ADD_ASSET',
  UPDATE_ASSET: 'UPDATE_ASSET',
  DELETE_ASSET: 'DELETE_ASSET'
}
